import { useEffect } from 'react';

// What sits at the "/" route now that the landing page is a static file.
//
// 2026-10-14: "/" is served by Caddy as client/public/landing.html, but that only happens on a real
// document request. React Router's own navigations — <Link to="/">, navigate('/'), <Navigate to="/">
// — are pushState, so Caddy never sees them and the router resolves "/" inside the app. Until this
// existed that resolved to the old SplashScreen, which meant logging out silently returned you to
// the page the landing page had replaced, looking like a different product.
//
// So the route stays, and its whole job is to leave the SPA.
//
// It targets /landing.html rather than "/" on purpose. Sending the browser to "/" would work in
// production, where Caddy rewrites it, and loop forever in `npm start`, where the dev server answers
// "/" with index.html — React would mount, land here again, and reload. Naming the file is true in
// both: Caddy's try_files serves it directly, and the dev server serves it out of public/.
//
// replace(), not assign(), so the dead entry is not left in the history for Back to return to.
const LandingRedirect = () => {
  useEffect(() => {
    window.location.replace('/landing.html');
  }, []);
  return null;
};

export default LandingRedirect;
